import { ChainId } from '@/lib/chain'

import { AddressMapper } from '../AddressMapper'
import {
  AAVE_ADDRESS,
  AGEUR_ADDRESS,
  ANKR_ADDRESS,
  APE_ADDRESS,
  ARB_ADDRESS,
  BCT_ADDRESS,
  BUSD_ADDRESS,
  COMP_ADDRESS,
  CRV_ADDRESS,
  DAI_ADDRESS,
  ENJ_ADDRESS,
  FEI_ADDRESS,
  FRAX_ADDRESS,
  FTM_ADDRESS,
  FXS_ADDRESS,
  GALA_ADDRESS,
  GNO_ADDRESS,
  JPY_ADDRESS,
  KLIMA_ADDRESS,
  KP3R_ADDRESS,
  LDO_ADDRESS,
  LINK_ADDRESS,
  LUSD_ADDRESS,
  MAI_ADDRESS,
  MANA_ADDRESS,
  MATIC_ADDRESS,
  MIM_ADDRESS,
  MKR_ADDRESS,
  NFTX_ADDRESS,
  OHM_ADDRESS,
  OP_ADDRESS,
  PRIMATE_ADDRESS,
  QUICK_ADDRESS,
  renBTC_ADDRESS,
  rETH2_ADDRESS,
  sETH2_ADDRESS,
  SNX_ADDRESS,
  SUSHI_ADDRESS,
  SWISE_ADDRESS,
  TRIBE_ADDRESS,
  TUSD_ADDRESS,
  UNI_ADDRESS,
  USDC_ADDRESS,
  USDT_ADDRESS,
  WBTC_ADDRESS,
  WETH9_ADDRESS,
  WNATIVE_ADDRESS,
  XSUSHI_ADDRESS,
  YFI_ADDRESS
} from './token-addresses'

const THUNDERCORE_USDT_ADDRESS = {
  [ChainId.THUNDERCORE]: '0x0dcb0cb0120d355cde1ce56040be57add0185baa'
}
const THUNDERCORE_USDC_ADDRESS = {
  [ChainId.THUNDERCORE]: '0xdc42728b0ea910349ed3c6e1c9dc06b5fb591f98'
}
const THUNDERCORE_WETH_ADDRESS = {
  [ChainId.THUNDERCORE]: '0xe6801928061cdbe32ac5ad0634427e140efd05f9'
}
const THUNDERCORE_BUSD_ADDRESS = {
  [ChainId.THUNDERCORE]: '0xb12c13e66ade1f72f71834f2fc5082db8c091358'
}

const BRIDGE_BSC_USDC_ADDRESS = {
  [ChainId.BTTC]: '0xca424b845497f7204d9301bd13ff87c0e2e86fcf'
}
const BRIDGE_ETHEREUM_USDC_ADDRESS = {
  [ChainId.BTTC]: '0xae17940943ba9440540940db0f1877f101d39e8b'
}
const BRIDGE_TRON_USDC_ADDRESS = {
  [ChainId.BTTC]: '0x935faa2fcec6ab81265b301a30467bbc804b43d3'
}
const BRIDGE_BSC_USDT_ADDRESS = {
  [ChainId.BTTC]: '0x9b5f27f6ea9bbd753ce3793a07cba3c74644330d'
}
const BRIDGE_ETHEREUM_USDT_ADDRESS = {
  [ChainId.BTTC]: '0xe887512ab8bc60bcc9224e1c3b5be68e26048b8b'
}
const BRIDGE_TRON_USDT_ADDRESS = {
  [ChainId.BTTC]: '0xdb28719f7f938507dbfe4f0eae55668903d34a15'
}

const MERGED_USDC_ADDRESS = AddressMapper.merge(
  USDC_ADDRESS,
  THUNDERCORE_USDC_ADDRESS,
  BRIDGE_BSC_USDC_ADDRESS,
  BRIDGE_ETHEREUM_USDC_ADDRESS,
  BRIDGE_TRON_USDC_ADDRESS
)

const MERGED_USDT_ADDRESS = AddressMapper.merge(
  USDT_ADDRESS,
  THUNDERCORE_USDT_ADDRESS,
  BRIDGE_BSC_USDT_ADDRESS,
  BRIDGE_ETHEREUM_USDT_ADDRESS,
  BRIDGE_TRON_USDT_ADDRESS
)

const MERGED_WETH_ADDRESS = AddressMapper.merge(
  WETH9_ADDRESS,
  THUNDERCORE_WETH_ADDRESS
)

const MERGED_BUSD_ADDRESS = AddressMapper.merge(
  BUSD_ADDRESS,
  THUNDERCORE_BUSD_ADDRESS
)

export const TOKEN_MAP = AddressMapper.generate([
  AAVE_ADDRESS,
  AGEUR_ADDRESS,
  ANKR_ADDRESS,
  APE_ADDRESS,
  ARB_ADDRESS,
  BCT_ADDRESS,
  COMP_ADDRESS,
  CRV_ADDRESS,
  DAI_ADDRESS,
  ENJ_ADDRESS,
  FEI_ADDRESS,
  FRAX_ADDRESS,
  FTM_ADDRESS,
  FXS_ADDRESS,
  GALA_ADDRESS,
  GNO_ADDRESS,
  JPY_ADDRESS,
  KLIMA_ADDRESS,
  KP3R_ADDRESS,
  LDO_ADDRESS,
  LINK_ADDRESS,
  LUSD_ADDRESS,
  MAI_ADDRESS,
  MANA_ADDRESS,
  MATIC_ADDRESS,
  MERGED_BUSD_ADDRESS,
  MERGED_USDC_ADDRESS,
  MERGED_USDT_ADDRESS,
  MERGED_WETH_ADDRESS,
  MIM_ADDRESS,
  MKR_ADDRESS,
  NFTX_ADDRESS,
  OHM_ADDRESS,
  OP_ADDRESS,
  PRIMATE_ADDRESS,
  QUICK_ADDRESS,
  renBTC_ADDRESS,
  rETH2_ADDRESS,
  sETH2_ADDRESS,
  SNX_ADDRESS,
  SUSHI_ADDRESS,
  SWISE_ADDRESS,
  TRIBE_ADDRESS,
  TUSD_ADDRESS,
  UNI_ADDRESS,
  WBTC_ADDRESS,
  XSUSHI_ADDRESS,
  YFI_ADDRESS
])
